var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.161,
    height: 26.161,
    viewBox: "0 0 26.161 26.161",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checked-out",
    transform: "translate(0 -0.878)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "checked-out-icon-green",
    transform: "translate(0 0.878)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "checked-out-2",
    "data-name": "checked-out"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    d: "M14.981,8.057a1.24,1.24,0,0,0-1.683,0L9.329,12.025l-1.2-1.2A1.19,1.19,0,0,0,6.44,12.5l1.048.992,1.056,1.056a1.166,1.166,0,0,0,1.628,0L14.981,9.74a1.24,1.24,0,0,0,0-1.683",
    transform: "translate(2.369 1.777)",
    fill: "#23bb79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M13.081,3.409a10.55,10.55,0,1,0,10.55,10.55,10.561,10.561,0,0,0-10.55-10.55m0,23.63A13.081,13.081,0,1,1,26.161,13.959,13.1,13.1,0,0,1,13.081,27.039",
    transform: "translate(0 -0.878)",
    fill: "#23bb79",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedOut);
export default __webpack_public_path__ + "static/media/checked-out.9d61135f9fb4d3f174c0b29a486a204f.svg";
export { ForwardRef as ReactComponent };